import { Reveal } from "./Reveal";

const PARTIES = [
  { who: "The adjuster", for: "works for the carrier", tone: "cool" },
  { who: "The preferred vendor", for: "works for the carrier's cost and volume targets", tone: "cool" },
  { who: "The contractor you choose", for: "works for you — and only you", tone: "warm" },
];

export const WhoseSide = () => {
  return (
    <section data-testid="whose-side-section" className="relative py-24 sm:py-32">
      <div className="mx-auto max-w-6xl px-5 sm:px-8">
        <Reveal className="max-w-2xl">
          <span className="font-mono text-[12px] tracking-[0.22em] uppercase text-erg-ember">
            No hidden loyalties
          </span>
          <h2 className="mt-4 font-display font-bold uppercase text-erg-ink leading-[0.95] text-[clamp(2rem,6vw,3.75rem)]">
            Whose side we're on
          </h2>
          <p className="mt-6 text-erg-ink/75 text-lg leading-relaxed text-pretty">
            There are three parties in an insurance loss. Two of them answer to the carrier.
            Only one answers to you.
          </p>
        </Reveal>

        <div className="mt-12 grid sm:grid-cols-3 gap-4 sm:gap-5">
          {PARTIES.map((p, i) => (
            <Reveal key={i} delay={i * 0.1}>
              <div
                className={`h-full rounded-2xl p-6 sm:p-7 border ${
                  p.tone === "warm"
                    ? "bg-erg-ink text-erg-dry border-erg-ember/50 shadow-[0_18px_40px_-18px_rgba(224,138,60,0.55)]"
                    : "bg-white/50 text-erg-ink border-erg-ink/10"
                }`}
              >
                <span
                  className={`font-mono text-[11px] tracking-[0.18em] uppercase ${
                    p.tone === "warm" ? "text-erg-ember" : "text-erg-mid"
                  }`}
                >
                  {String(i + 1).padStart(2, "0")}
                </span>
                <h3 className="mt-3 font-display font-semibold text-2xl leading-tight">
                  {p.who}
                </h3>
                <p className={`mt-2 leading-relaxed ${p.tone === "warm" ? "text-erg-dry/80" : "text-erg-ink/70"}`}>
                  {p.for}
                </p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.15} className="mt-10 max-w-3xl">
          <p className="text-erg-ink/80 text-lg leading-relaxed text-pretty">
            We document the water source and the damage thoroughly, so the facts of your loss
            are recorded clearly and early. We don't tell you what your policy covers or whether
            you'll be reimbursed — those questions belong with your declarations page and your
            broker. What we do is get the water out, get your home dry, and document every step
            along the way.
          </p>
        </Reveal>
      </div>
    </section>
  );
};
